var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSort4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_178_133",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_178_133",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAWdJREFUSEvtlb9KA0EYxGeSSiGFkGT3Qoha6wMoaik2voAg/gNbY2PhGwiCiK2IFoKFD6DYKCha2dkrAXO7uRSCaGOST04usIgJhIukyTZX7fx25uPmI/758J/10VtAJpOZJnlGctdae+C69TxvptFonNbr9fFqtfreKomWDrLZ7BTJCwCp6PK2tXanKaS1XhGRY5KjxpiXjgCR+CWA8GUeAD/6FptO4gLOSY4BWAPwAGAdwCyACWvtcPjaWIB8Pj8QitRqNSUizyRXjTEnuVxusFwuf8YGODmPuAA351gO+gA3yrZ/sta6P4P2ZdeTiAqFwlCpVHrTWi87XfQaDfbrdyd1PGSlVADgGsAVgEMAkwCOSD4aY5a6ASgC2HcKMCzClIjMVSqV+9iAUEAptQlgD/iZ4QfJeWPMzV+V3TaidDqdSiaTT4lEYtH3/VtXQCm1ISJbIrIQBMFdR/ugm3u6tzu5G06+AScPJigMuWa7AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort4);
export default __webpack_public_path__ + "static/media/sort_4.1527f5ba4c51b09105c619de1709e41b.svg";
export { ForwardRef as ReactComponent };